import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles<Theme>((theme) => ({
  block: {
    width: '100%',
    maxWidth: 436,
    minWidth: 436,
    fontSize: 14,
    '&.full': {
      maxWidth: '100%',
      minWidth: '100%',
    },
    '@media (max-width: 767px)': {
      maxWidth: '100%',
      minWidth: '100%',
    }
  },

  fieldsWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: 16,
    '& > div': {
      width: "100%",
    },
    '& > .MuiDivider-root': {
      width: "100%",
      margin: "8px 0",
    }
  },

  field: {
    display: "inline-flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 4,
    width: "100%",
    '& .MuiTypography-body2': {
      lineHeight: "24px",
    }
  },
  fieldLabel: {},
  fieldContent: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    flexDirection: "column",
    gap: 4,
  },

  step: {
    display: "inline-flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    gap: 4,
    fontWeight: 400,
    fontSize: "0.875rem",
  },

  groupWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: 16,
  },
  group: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
    gap: 16,
    '&.last-filter': {
      order: 9999,
      '& .MuiDivider-root': {
        display: "none!important",
      }
    },
    '&.one': {
      '& .MuiDivider-root': {
        display: "none!important",
      }
    },
    '&.default-filter': {
      '&:last-child': {
        '& .MuiDivider-root': {
          display: "none!important",
        }
      }
    },
    '& > div': {
      width: "100%",
    },
    '& > .MuiDivider-root': {
      width: "100%",
      margin: "8px 0",
    }
  },
  filterWrapper: {
    display: "inline-flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    gap: 4,
  },
}));
